import { Box, Paper, Typography } from '@mui/material'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ContainerSidebar from './Components/ContainerSidebar'
import FieldConfigGrid from './Components/FieldConfigGrid'

const FieldConfigPage = () => {
  const { t } = useTranslation()
  const [selectedDb, setSelectedDb] = useState<string | null>(null)
  const [selectedContainer, setSelectedContainer] = useState<string | null>(null)

  const handleSelectContainer = (dbName: string, containerName: string) => {
    setSelectedDb(dbName)
    setSelectedContainer(containerName)
  }

  const handleBackToDatabases = useCallback(() => {
    setSelectedDb(null)
    setSelectedContainer(null)
  }, [])

  return (
    <Paper sx={{ mt: 2, mb: 2, borderRadius: 2, display: 'flex', height: 'calc(100vh - 180px)' }}>
      <ContainerSidebar
        selectedContainer={selectedContainer}
        onSelectContainer={handleSelectContainer}
        onBackToDatabases={handleBackToDatabases}
      />
      <Box sx={{ flexGrow: 1, p: 2, display: 'flex', flexDirection: 'column' }}>
        {selectedDb && selectedContainer ? (
          <>
            <Typography variant="h6" sx={{ mb: 1 }}>
              {selectedDb} &gt; {selectedContainer}
            </Typography>
            <FieldConfigGrid dbName={selectedDb} containerName={selectedContainer} />
          </>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Typography color="text.secondary">{t('anonymizer.selectPrompt')}</Typography>
          </Box>
        )}
      </Box>
    </Paper>
  )
}

export default FieldConfigPage
